module.exports = __webpack_public_path__ + "static/media/DSC_6448_s.99b62310.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wedding_engage/DSC_6448_s.jpg
// module id = 266
// module chunks = 0